module.exports = __webpack_public_path__ + "b06715c21a3d7eebec49995905ce1f5a.png";


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/moma/nav-light-right.png
// module id = 713
// module chunks = 0 1 2 3 4 5